import { PAGINATION_INITIAL_PAGE } from 'constants/constants';
import { useState } from 'react';

export const useInfinitePagination = () => {
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(PAGINATION_INITIAL_PAGE);

  const nextPage = () => {
    if (!hasMore) return;
    setPage(prev => prev + PAGINATION_INITIAL_PAGE);
  };

  const reset = () => {
    setPage(PAGINATION_INITIAL_PAGE);
    setHasMore(false);
  };

  return { page, hasMore, nextPage, reset, setHasMore };
};
